/**
 * Run async tasks with a max concurrency. Needed on EU sandbox where the
 * Lambda account concurrent-executions quota is still low (default 10).
 */
export async function mapPool(items, concurrency, worker) {
  const results = new Array(items.length);
  let next = 0;
  const runners = Array.from(
    { length: Math.min(concurrency, items.length) },
    async () => {
      while (next < items.length) {
        const i = next++;
        results[i] = await worker(items[i], i);
      }
    }
  );
  await Promise.all(runners);
  return results;
}
